<!-- <app-loader *ngIf="isLoading"></app-loader> -->
<router-outlet disableRightClick />
<app-dev-bypass-helper></app-dev-bypass-helper>
<router-outlet></router-outlet>